<template>
    <div class="cabinet-content-wrap">
        <header class="cabinet-header flex flex-align-center">
            <a
                v-show="routeFrom && routeFrom.name"
                href="#"
                class="cabinet-btn--back  cabinet-btn--back-list"
                @click.prevent="$router.go(-1)"
            ></a>
            <h1 class="h1 cabinet-title">Заказ №{{ order.OrderNo }}</h1>
        </header>
        <div v-if="loading">Loading...</div>
        <div v-else-if="errors.getOrder">
            <div class="error text-center">
                <div class="error-image">
                    <img src="/img/icons/error.svg" alt="" />
                </div>
                <div class="error-title">
                    Упс! Что-то пошло не так.
                </div>
                <div class="error-button">
                    <button
                        type="button"
                        class="cabinet-btn"
                        @click="tryLoadingOrder"
                    >
                        Попробовать еще раз
                    </button>
                </div>
            </div>
        </div>

        <section
            v-else-if="!errors.getOrder && order"
            class="v2-retailer-order"
        >
            <div class="v2-retailer-order__top">
                <div class="v2-retailer-order__top-left">
                    <div class="v2-retailer-order__top-cell">
                        <div class="v2-retailer-order__top-key">Оформлен</div>
                        <div class="v2-retailer-order__top-val">
                            {{
                                getFormattedDate(order.RegDate, 'DD MMMM YYYY')
                            }}
                        </div>
                    </div>
                    <div class="v2-retailer-order__top-cell">
                        <div class="v2-retailer-order__top-key">Покупатель</div>
                        <div class="v2-retailer-order__top-val">
                            {{ order.Contacts ? order.Contacts.Name : '' }}
                        </div>
                        <div class="v2-retailer-order__top-val">
                            {{ order.Contacts ? order.Contacts.Phone : '' }}
                        </div>
                        <div class="v2-retailer-order__top-val">
                            {{ order.Contacts ? order.Contacts.Email : '' }}
                        </div>
                        <div
                            v-if="order.retailer"
                            class="v2-retailer-order__top-val"
                        >
                            {{ order.retailer.company_name }}
                        </div>
                    </div>
                </div>
                <div class="v2-retailer-order__top-right">
                    <div class="v2-retailer-order__top-detail">
                        <div
                            v-for="brand in order.ItemsByBrand"
                            :key="brand.BrandID"
                            class="v2-retailer-order__top-val"
                        >
                            {{ brand.BrandName }},
                            {{ orderItemsCountByBrand(brand.BrandID) }} шт,
                            {{
                                getFormattedNum(
                                    orderItemsPriceByBrand(
                                        brand.BrandID
                                    ).toFixed(2)
                                )
                            }}
                            Р
                        </div>
                    </div>
                    <div class="v2-retailer-order__top-total">
                        Итого: ~
                        {{ getFormattedNum(orderTotalPrice.toFixed(2)) }} Р
                    </div>
                </div>
            </div>
            <div class="v2-retailer-order__body">
                <div
                    v-for="brand in order.ItemsByBrand"
                    :key="brand.BrandID"
                    class="v2-retailer-order__brand"
                >
                    <div class="v2-retailer-order__brand-title">
                        {{ brand.BrandName }}
                    </div>
                    <order-product-item
                        v-for="product in brand.Items"
                        :key="product.ItemID"
                        :product="product"
                    />
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import getFormattedDate from '@/utils/getFormattedDate'
import getFormattedNum from '@/utils/getFormattedNum'
import getNameById from '@/mixins/getNameById'

import OrderProductItem from '@/components/Cabinet/Supplier/Orders/OrderProductItem'

export default {
    name: 'SupplierOrder',
    components: { OrderProductItem },
    mixins: [getNameById],
    data() {
        return {
            loading: true,
            routeFrom: {}
        }
    },
    computed: {
        ...mapState('supplierOrders', ['order', 'errors']),
        ...mapGetters('supplierOrders', [
            'orderItemsCountByBrand',
            'orderItemsPriceByBrand',
            'orderTotalPrice'
        ]),
        ...mapState('supplierBrand', ['brands']),
        itemsTotalCount() {
            if (!this.order.ItemsByBrand) return ''

            let totalCount = 0

            totalCount = this.order.ItemsByBrand.reduce((acc, brand) => {
                return (
                    acc +
                    brand.Items.reduce((brandAcc, item) => {
                        return brandAcc + parseInt(item.pivot.Quantity)
                    }, 0)
                )
            }, 0)

            return totalCount
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.routeFrom = from
        })
    },
    async mounted() {
        await this.tryLoadingOrder()
    },
    methods: {
        ...mapActions('supplierOrders', ['getOrder']),
        ...mapActions('supplierBrand', ['getBrands']),
        getFormattedDate,
        getFormattedNum,
        async tryLoadingOrder() {
            this.loading = true
            await this.getOrder(this.$route.params.id)
                .catch(() => {
                    this.loading = false
                })
                .then(() => {
                    this.loading = false
                    this.getBrands()
                })
        }
    }
}
</script>
